(() => {
  if (window.soulfeltEditorialInitialized) return;
  window.soulfeltEditorialInitialized = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
    });
  }, { threshold: .08 }) : null;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-sf-process-toggle]').forEach((button) => {
      if (button.dataset.sfVideoBound) return;
      button.dataset.sfVideoBound = 'true';
      const video = button.parentElement.querySelector('video');
      if (!video) return;
      if (motion.matches) { video.removeAttribute('autoplay'); video.pause(); }
      const sync = () => {
        button.setAttribute('aria-pressed', String(!video.paused));
        button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('path').setAttribute('d', video.paused ? 'm8 5 11 7-11 7Z' : 'M6 5h4v14H6zm8 0h4v14h-4z');
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(sync);
        else video.pause();
      });
      sync();
    });
    if (reveal && !motion.matches) scope.querySelectorAll('.sf-pdp-editorial[data-sf-motion="true"] [data-animate]').forEach(element => {
      if (element.dataset.sfMotionBound) return;
      element.dataset.sfMotionBound = 'true';
      element.classList.add('sf-pdp-enter');
      reveal.observe(element);
    });
    scope.querySelectorAll('.sf-pdp-editorial img').forEach((image) => {
      const loaded = () => image.closest('.loading')?.classList.remove('loading');
      if (image.complete) loaded();
      else image.addEventListener('load', loaded, { once: true });
    });
    scope.querySelectorAll('.sf-pdp-editorial details').forEach((details) => {
      if (details.dataset.sfBound) return;
      details.dataset.sfBound = 'true';
      details.addEventListener('toggle', () => details.setAttribute('aria-expanded', String(details.open)));
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.sf-pdp-editorial .sf-pdp-lp-like-button');
    if (!button || button.getAttribute('aria-pressed') === 'true') return;
    button.setAttribute('aria-pressed', 'true');
    const count = button.querySelector('.sf-pdp-lp-like-count');
    if (count) count.textContent = (Number(count.textContent.replaceAll(',', '')) + 1).toLocaleString('en-US');
    button.classList.add('is-liked');
  });
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
